// extracted by mini-css-extract-plugin
module.exports = {"background":"loginbackground_background__ISM8N","video":"loginbackground_video__3lZK4"};